import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";

import { NOTIFY, DEFAULTS } from "common/config";
import {
  LABELS,
  ERRORS,
  WARNINGS,
  SUCCESS,
  CONFIRMS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { ApiReports } from "apihandlers//reports";
import { ApiIndents } from "apihandlers//indent";
import { ApiMasters } from "apihandlers//masters/masters";
const ApiReportsHandler = new ApiReports();
const ApiIndentsHandler = new ApiIndents();
const ApiMastersHandler = new ApiMasters();

const VehiclesLocation = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState<any>({});
  const [masters, setMasters] = useState<any>([]);
  const [rows, setRows] = useState<any>(null);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [exportName, setExportName] = useState("");

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "dlNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DL_NUMBER,
      width: "10%",
    },
    {
      key: "vehicleNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VEHICLE_NO,
      width: "10%",
    },
    {
      key: "indentNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.INDENT_NO,
      width: "10%",
    },
  ];

  useEffect(() => {
    if (loading) {
      getMasterData();
    }
  }, [loading]);

  const getMasterData = () => {
    const args = { shortMode: true };
    ApiMastersHandler.getVehicles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list: any = [{ id: -1, label: "All" }];
        let recs: any = response.records;
        for (let i = 0; i < recs.length; i++) {
          list.push({
            id: recs[i].id,
            label: recs[i].vehicleNumber,
          });
        }
        setMasters(list);
        setLoading(false);
      }
    });
  };

  // const generateReportGrid = (res: any) => {
  //   let title = LABELS.VEHICLE_LOCATION_REPORT;
  //   if (masterRef.current) {
  //     title += " - " + masterRef.current.selectedValue.label;
  //   }
  //   $("#reportGrid").DataTable({
  //     dom: "Bfrtip",
  //     buttons: [
  //       {
  //         extend: "csv",
  //         className: "reportBtn",
  //         title: title,
  //         text: "<i class='fa fa-download'></i>",
  //       },
  //     ],
  //     paging: true,
  //     pageLength: 15,
  //     columns: [
  //       {
  //         title: "Sl No.",
  //       },
  //       {
  //         title: "Vehicle Number",
  //       },
  //       {
  //         title: "IMEI",
  //       },
  //       {
  //         title: "Driver Name",
  //       },
  //       {
  //         title: "Driver Number",
  //       },
  //       {
  //         title: "Location",
  //         render: function (data, type, row, meta) {
  //           if (type === "display") {
  //             data =
  //               '<a target="_blank" href="https://www.google.com/maps?q=' +
  //               row[5] +
  //               '">' +
  //               row[5] +
  //               "</a>";
  //           }
  //           return data;
  //         },
  //       },
  //     ],
  //     data: res,
  //     order: [],
  //   });
  // };

  const loadChart = () => {
    // const id = masterRef.current.selectedValue.id;
    // if (!id) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.DATA_IS_EMPTY);
    //   return;
    // }
    // const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
    //   .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    setExportName(LABELS.LOCATION_DATE + ":" + toDt);
    const args = {
      dt: toDt,
    };
    // if ($.fn.dataTable.isDataTable("#reportGrid")) {
    //   let table = $("#reportGrid").DataTable();
    //   table.destroy();
    // }
    // if ($("#reportGrid")) {
    //   $("#reportGrid").empty();
    // }
    setChartData(null);
    ApiIndentsHandler.getVehicleOnMap(args).then((res) => {
      const response: any = Object.values(res.response);
      console.log("getVehicleOnMap:", response);
      const { status } = res;
      if (status === 200) {
        setChartData(response);
        // setTimeout(() => {
        //   const rows = [];
        //   for (let i = 0; i < response.length; i++) {
        //     const row = response[i];
        //     rows.push([
        //       i + 1,
        //       row.vehicleNumber,
        //       row.gpsimei,
        //       row.driverName,
        //       row.driverNumber,
        //       row.latitude + "," + row.longitude,
        //     ]);
        //   }
        //   generateReportGrid(rows);
        // }, 500);
      }
    });
  };

  const masterRef: any = useRef();

  // console.log("elist:", masters);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.DASHBOARD}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.VEHICLE_LOCATION_REPORT}</li>
        </ul>
        <h4>{TITLES.VEHICLE_LOCATION_REPORT}</h4>
        <p className="SubTitles">{SUB_TITLES.VEHICLE_LOCATION_REPORT}</p>
      </div>
      {loading ? (
        <div className="flexCenter" style={{ minHeight: 450 }}>
          <Loader />
        </div>
      ) : (
        <div className="hChart">
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            {/* <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: 5,
                marginBottom: 10,
                width: "40%",
              }}
            >
              <label>{"Select Vehicle :"}</label>
              <AutoComplete
                id={"masters"}
                list={masters}
                childRef={masterRef}
                defaultValue={{ id: -1, label: "All" }}
              />
            </div> */}
            <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 0,
                marginBottom: 20,
              }}
            >
              {/* <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.FROM_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="fromDt"
                  defaultValue={DateFunctions.getDate(
                    "today",
                    "from",
                    "YYYY-MM-DD"
                  )}
                />
              </div> */}

              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.LOCATION_DATE}
                </label>
                <TxtBox
                  type={"datetime-local"}
                  id="toDt"
                  defaultValue={DateFunctions.getDate(
                    "thismonth",
                    "to",
                    "YYYY-MM-DD HH:mm:ss"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                }}
              >
                <Btn
                  text={LABELS.LOAD}
                  onClick={loadChart}
                  // loading={!chartData}
                />
              </div>
            </div>
          </div>

          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {rows && (
            <ExcelGrid
              id={"vehiclLocationreport"}
              title={LABELS.VEHICLE_LOCATION_REPORT}
              height={window.innerHeight * 0.75}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={exportName}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(VehiclesLocation);
